goog.provide('el8.appchart.dialog.addEditProblem');

goog.require('el8.data.practiceSettings');
goog.require('el8.appchart.refpanel.demog');
goog.require('el8.appservice.notifier');
goog.require('el8.appshared.form.buttons');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.data.imos');
goog.require('el8.ptdata.hccScoreDetails');
goog.require('el8.ptdata.ptProblems');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.dialog.addEditProblem');
goog.require('el8.template.appshared.imo');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.consts');
goog.require('el8.util.validate');

//
// This is a dialog for adding and editing patient problems
//
// It uses the new IMO-term based mindreader to allow the user to select an IMO "term"
// which is an association of  ([list of icd10s], [list of icd9s], snomed)with associated
// data. It is also used for "crosswalking" a problem with list of "legacy" icd9s to the
// new IMOs. Another feature is a fallback to the existing icd9 search if the API call
// to IMO fails.
//
el8.appchart.dialog.addEditProblem = (function() {
    var currProblem = null;
    var description = null;
    var details = null;
    var saveCb = null;
    var form = null;
    var _mindreader = null;
    var $contentElt = null;
    var localImoCodeIds = [];
    var fallbackToIcd9 = false;

    var that = new el8.uiwidget.FormDialog({
        title: 'Edit Patient Problem',
        autoHeight: true,
        width: el8.data.practiceSettings.isHccScoringEnabled() ? 620 : 570,
        contentFn: function() {
            return el8.template.appchart.dialog.addEditProblem.form({
                statusChoices: el8.util.consts.PROBLEM_STATUS_CHOICES,
                hccScoringEnabled: el8.data.practiceSettings.isHccScoringEnabled()
            });
        },
        showXButton: el8Globals.READ_ONLY
    });

    var saveFn = function(_form, addAnother, isCrosswalking) {
        var startDate = el8.util.datecompare.dateFromStr(form.getVal('startDate'));
        if (!startDate || el8.util.datecompare.isAfterToday(startDate)) {
            el8.uiwidget.alert('Please enter a start date that is today or earlier',
                               form.getInfoField('startDate').getInputField());
            return;
        }

        if (!_form.isValid()) {
            el8.uiwidget.nonAlarmingAlert('Please fill out the starred fields.');
            return;
        }

        if (!currProblem) {
            currProblem = el8.ptdata.ptProblems.create(form.getMapped(), true);
        } else {
            currProblem.setDescription(form.getVal('description'));
            currProblem.setStartDate(form.getVal('startDate'));
            currProblem.setStatus(form.getVal('status'));
            currProblem.setDetails(form.getVal('details'));
        }

        if (fallbackToIcd9) {
            // IMO is down and we've fallen back to "legacy" ICD9s
            var icd9Ids = $('.term-item', $contentElt).map(function(i, e){
                return $(e).data('id');
            }).get();
            currProblem.setIcd9Codes([]);
            currProblem.setIcd9Ids(icd9Ids);
        } else {
            // Otherwise, we're using IMOs and should clear any 9's except
            // when no IMO was selected
            currProblem.setImoIds(localImoCodeIds); // our code ids, will clear if []
            if (localImoCodeIds.length) {
                currProblem.setIcd9Codes([]);
                currProblem.setIcd9Ids([]);
            }
        }

        // if we're xwalking a resolved problem, signal the view to keep the current resolved date
        if (isCrosswalking && (currProblem.getStatus() === 'Resolved')) {
            currProblem.setStatus('ResolvedXwalk');
        }

        el8.ptdata.ptProblems.saveItem(currProblem, false, {
            successCb: function() {
                if (saveCb) { saveCb(currProblem); }

                // Refresh the pt hcc score
                el8.ptdata.hccScoreDetails.refreshIfHccScoreEnabled();

                that.hide();

                if (addAnother && isCrosswalking) {
                    var needsCrosswalk = el8.ptdata.ptProblems.sorted().filter(function(p) {
                        return !p.getImoIds().length;
                    });
                    that.show({ problem: _(needsCrosswalk).first() });
                    $(document).trigger('problem-dialog-crosswalk-another');
                } else if (addAnother) {
                    that.show();
                } else if (el8Globals.TEASE) {
                    $(document).trigger('problem-dialog-final-close');
                }
            }
        });
    };

    that._createForm = function() {
        var fields = [
            {
                name: 'description',
                selector: ':input[name="description"]',
                height: el8.util.consts.XL_FIELD_HEIGHT,
                infoText: 'Problem description...',
                maxLength: 200,
                validate: { required: true }
            },
            {
                name: 'startDate',
                selector: ':input[name="startDate"]',
                infoText: 'Date diagnosed...',
                datePickerOpts: {},
                defaultVal: function() { return el8.service.tz.today().asString(); },
                validate: {
                    required: true,
                    validDate: true,
                    todayOrBefore: true
                }
            },
            {
                name: 'status',
                selector: ':input[name="status"]'
            },
            {
                name: 'details',
                selector: ':input[name="details"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT*5,
                infoText: 'Problem synopsis...'
            }
        ];

        form = new el8.uiwidget.Form({
            fields: fields,
            validationOpts: el8.util.validate.standardOpts,
            noFirstFocus: true
        });

        el8.appshared.form.buttons.addNonDraftDialogButtons(form, saveFn, that);
        that.setForm(form);
    };

    var _createTooltipsForImo = function (imo) {
        var _createTT = function (pair, codeType) {
            var code = pair[0];
            var description = pair[1];

            var divsWithoutTTs = $('div[data-code="'+code+'"]:not(.has-tippy)', $contentElt);

            _.each(divsWithoutTTs, function (div) {
                el8.service.tooltip.create({
                    anchor: $(div),
                    text: el8.template.appshared.imo.tooltip({
                        code: code,
                        codeType: codeType,
                        description: description
                    }),
                    placement: 'top',
                    theme: 'gray',
                    showDelay: 300,
                    interactive: true
                });
            });
        };

        _.each(_.zip(imo.getIcd9Codes(), imo.getIcd9Descriptions()), function(pair) {
            _createTT(pair, 'ICD-9');
        });

        _.each(_.zip(imo.getIcd10Codes(), imo.getIcd10Descriptions()), function(pair) {
            _createTT(pair, 'ICD-10');
        });

        _createTT([imo.getSnomed(), imo.getSnomedDescription()], 'SNOMED');
    };

    /**
     * Helper to get jQuery selector for problem search field input
     */
    that._getSearchFieldSelector = function() {
        return el8Globals.FEATURES.BillDxNavigator ?
            '#add-edit-problem-dx-nav input' : ':input[name="query"]'
    }

    /**
     * Helper to get jQuery element for problem search field input
     */
    that._getSearchFieldElt = function(context) {
        return $(that._getSearchFieldSelector(), context);
    }

    /**
     * Handler to set the default query for the Dx Navigator input
     * Sets the input value using mechanisms to simulate React's onChange event
     * @param {HTMLInputElement} inputElement
     * @param {string} value
     */
    that._handleSetDxNavDefaultQuery = function (inputElement, value) {
        var nativeInputValueSetter = Object.getOwnPropertyDescriptor(
            window.HTMLInputElement.prototype,
            "value").set;
        nativeInputValueSetter.call(inputElement, value);
        var inputEvent = new Event("input", { bubbles: true });
        inputElement.dispatchEvent(inputEvent);
    }

    var super_init = that._init;
    that._init = function() {
        that._createForm();
        super_init.call(that);
        $contentElt = that.getDialogContentElt();

        //
        // Custom dialog MR opts
        //
        var dialogCustomMrOpts = {
            formatSelected: function(item) {
                return ''; // just clear this MR's input
            },
            selectFn: function(event, item) {
                if (item.imo_code) {
                    // We get "imo_code" (i.e. IMO's vendor id) back here -- not our IMO pk

                    // Check if we have this IMO (by vendor it) in the FE eSet (with noFetch == True)
                    var localImo = el8.data.imos.getByKey(item.imo_code, true);

                    // If we have this IMO locally, remove it from the FE eSet. Why? We
                    // might have a mapping update from IMO and we want to use the latest maps
                    // instead of any FE cached maps from existing problems or a/p bullets
                    // in this chart.
                    if (localImo) { el8.data.imos.remove(localImo); }

                    // Force a fetch / refresh of this code down to the FE. This will
                    // guarantee any mapping changes will be sent to the FE.
                    var imo = el8.data.imos.getByKey(item.imo_code);

                    localImoCodeIds.push(imo.getId()); // save selected imo id

                    if (!form.getVal('description')) {
                        form.setVal('description', imo.getDescription());
                    }

                    // FUTURE: Identify ICD-10 codes as valid/invalid based on Date of Service
                    var isTermNonBillable = imo.isImoNonBillable();
                    var isTermDisabled = el8Globals.FEATURES.BillDxAllowInvalid ? false : isTermNonBillable;

                    $('.term-list', $contentElt).append(
                        el8.template.appshared.imo.term({
                            term: {
                                'id': imo.getId(),
                                'title': imo.getDescription(),
                                'icd9s': imo.getIcd9Codes(),
                                'icd10s': imo.getIcd10Codes(),
                                'icd10NonBillables': imo.getIcd10NonBillables(),
                                'snomed': imo.getSnomed(),
                                // The downstream code expects a list but in this specific use case we only want the latest
                                'hccCategories': imo.getLatestHccCategory() ? [imo.getLatestHccCategory()] : []
                            },
                            'hccScoringEnabled': el8.data.practiceSettings.isHccScoringEnabled(),
                            isTermNonBillable: isTermNonBillable,
                            isTermDisabled: isTermDisabled
                        })
                    );
                    $('.term-list-section', $contentElt).show();
                    $('.term-search-section', $contentElt).hide();
                    $('.add-trigger-section', $contentElt).show();

                    // focus problem title/description
                    $(':input[name="description"]', $contentElt).focusFocus();

                    that.adjustHeight();

                    _createTooltipsForImo(imo);
                } else {
                    // This is a legacy icd9 code (for fallback). Since we've failed to talk to IMO,
                    // clear the localImoCodeIds so we don't get into a bad mixed state
                    // e.g. {score: 10.650341, code: "22.2", mapped_snomed: "111798006",
                    // id: 25681657905, description: "INTRANASAL ANTROTOMY"}
                    fallbackToIcd9 = true;
                    localImoCodeIds = [];

                    if (!form.getVal('description')) {
                        form.setVal('description', item.description);
                    }

                    $('.term-list', $contentElt).append(
                        el8.template.appshared.imo.legacyTerm({ term: item })
                    );
                    $('.term-list-section', $contentElt).show();
                    $('.term-search-section', $contentElt).hide();
                    $('.add-trigger-section', $contentElt).show();

                    // focus problem title/description
                    $(':input[name="description"]', $contentElt).focusFocus();
                    that.adjustHeight();
                }
            },
            modifyRenderCb: function(args) {
                if (args.numMatches === 0) {
                    args.infoDiv.text( 'No results found for "' + args.searchString + '"');
                } else {
                    if (args.infoDiv.is(':visible')) {
                        // show the HCC header if flag on
                        var tmpl = null;
                        if (el8.data.practiceSettings.isHccScoringEnabled()) {
                            tmpl = el8.template.appshared.imo.termListHeaderWithHCC;
                        } else {
                            tmpl = el8.template.appshared.imo.termListHeader;
                        }
                        args.mrSections[0].prepend(tmpl({mindreader: true}));
                    }
                }
            }
        };

        // Show DX Navigator or legacy mindreader for problem search input
        if (el8Globals.FEATURES.BillDxNavigator) {
            var dxNavContainerId = 'add-edit-problem-dx-nav';
            $("#" + dxNavContainerId).show();

            // FUTURE: Any use-cases to set BillDxNavMindreader `showActiveImo` prop to
            // show recent VN assessment activity or problems (e.g. sync VN -> PT Problems)?
            el8React.render.billDxNavMindreader(dxNavContainerId, {
                'data-testid': 'add-edit-problem-dx-nav-input',
                onSelect: function (item) {
                    // Use existing mindreader selectFn to process selected item
                    dialogCustomMrOpts.selectFn(null, item);
                },
                placeholder: 'Start typing a description or code (ICD-10, ICD-9, SNOMED)'
            });
        } else {
            var searchContainerElt = that._getSearchFieldElt().parent();
            searchContainerElt.show();
            // Merge opts and init mindreader
            _mindreader = (new el8.uiwidget.NewMindreader(
                $.extend(el8.appshared.mindreaderOpts.imos('icd9'),
                         dialogCustomMrOpts))
            )
            .init($(':input[name="query"]', that.getDialogContentElt()));
        }
    };

    var _refresh = function() {
        // clear and reset the term list, source codes list, buttons
        $('#problem-section li').removeClass('el8BlueHighlightList');

        $('.term-list', $contentElt).empty();

        $('.add-trigger-section', $contentElt).show();
        $('.source-codes-section', $contentElt).empty();
        $('.source-problem-section', $contentElt).empty();

        // FUTURE: How can we reset/clear DX Navigator input from legacy?
        if (_mindreader) {
            _mindreader.setInputVal('');
        }

        form.getButtonSet().removeButtons();
        el8.appshared.form.buttons.addNonDraftDialogButtons(form, saveFn, that);
    };

    var _insertCurrentProblem = function() {
        // Edit or Crosswalk: save current state, populate form, add terms to
        form.populate({
            'description': currProblem.getDescription(),
            'startDate': currProblem.getStartDate().asString(),
            'status': currProblem.getStatus(),
            'details': currProblem.getDetails()
        });

        var unprocessableDx = [];

        _(currProblem.getImoIds()).each(function (imoId) {
            // DX mapping may be cache invalided and/or no longer available from IMO service
            // While invalid for billing, the practice should ultimately determine how to resolve
            // out-of-date or invalid DX (replace, remove, leave as-is, etc.)
            var imo = el8.data.imos.getByIdIncludingDeleted(imoId);
            if (!imo) {
                unprocessableDx.push(imoId);
                return;
            }

            localImoCodeIds.push(imoId);

            // FUTURE: Identify ICD-10 codes as valid/invalid based on Date of Service
            var isTermNonBillable = imo.isImoNonBillable();
            var isTermDisabled = el8Globals.FEATURES.BillDxAllowInvalid ? false : isTermNonBillable;

            $('.term-list', $contentElt).append(
                el8.template.appshared.imo.term({
                    term: {
                        'id': imo.getId(),
                        'title': imo.getDescription(),
                        'icd9s': imo.getIcd9Codes(),
                        'icd10s': imo.getIcd10Codes(),
                        'icd10NonBillables': imo.getIcd10NonBillables(),
                        'isDeleted': imo.isDeleted(),
                        'snomed': imo.getSnomed(),
                        // The downstream code expects a list but in this specific use case we only want the latest
                        'hccCategories': imo.getLatestHccCategory() ? [imo.getLatestHccCategory()] : [],
                        'lastAddressedDate': currProblem.getImoLastAddressedDates()[imoId]
                    },
                    'hccScoringEnabled': el8.data.practiceSettings.isHccScoringEnabled(),
                    isTermNonBillable: isTermNonBillable,
                    isTermDisabled: isTermDisabled
                })
            );

            _createTooltipsForImo(imo);
        });

        if (unprocessableDx.length > 0) {
            var unprocessableErrorText = "Error unable to load DX code(s): " + unprocessableDx.join(', ');
            el8.appservice.notifier.notify(unprocessableErrorText);
            console.error(unprocessableErrorText);
        }

        // If we got additional details/synopsis from a VN overwrite or append
        if (details) {
            if (currProblem.getDetails()) {
                form.populate({'details': currProblem.getDetails() + '\n\n' + details});
            } else {
                form.populate({'details': details});
            }
        }
    };

    var _edit = function () {
        // Edit (has IMOs)
        that.setTitle('Edit Patient Problem');
        $('.term-list-section', $contentElt).show();
        $('.term-search-section', $contentElt).hide();
        form.showDiscardChangesCaption();
    };

    var _crosswalk = function (isLast) {
        var icd9Codes = currProblem.getIcd9Codes();
        var snomedCodes = currProblem.getSnomedCodes();
        var inputVal = null;

        // Highlight the currProblem
        var elt = $('#problem-section li').filter(function(i,v) {
            return $(v).data('id') === currProblem.getId();
        } );
        $(elt).addClass('el8BlueHighlightList');

        that.setTitle('Crosswalk Patient Problem');
        $('.term-list-section', $contentElt).hide();

        // Update buttons
        if (!isLast) {
            form.getButtonSet().removeButtons();
            form.addSaveAndAnotherButton(function(_form) {
                // 2nd param = "addAnother", 3rd param = "xwalking"
                saveFn(_form, true, true);
            }, true);
            form.addSaveButton(function(_form) {
                saveFn(_form, false, true);
            }, false);
            form.addDiscardButton(function() {
                that.hide();
                if (el8Globals.TEASE) {
                    $(document).trigger('problem-dialog-final-close');
                }
            });
            form.renderButtonSet();
            form.updateButtonCaption('save-and-another', 'Save & Crosswalk Another');
        }

        // Inject list of source codes if we have them
        if (icd9Codes.length || snomedCodes.length) {
            $('.source-problem-section', $contentElt).html(
                el8.template.appshared.imo.sourceProblem({
                    description: currProblem.getDescription()
                })
            )
            .show();

            $('.source-codes-section', $contentElt).html(
                el8.template.appshared.imo.sourceCodes({
                    icd9Codes: icd9Codes,
                    snomedCodes: snomedCodes
                })
            )
            .show();
        }

        // Search with 9's first (removed snomed which isn't working...)
        if (icd9Codes.length) {
            // use first icd9
            inputVal = icd9Codes[0];
        } else if (currProblem.getDescription()) {
            inputVal = currProblem.getDescription();
        }

        $('.term-search-section', $contentElt).show();

        if (_mindreader) {
            _mindreader.setInputVal(inputVal);
            _mindreader.requestResults(inputVal);
        }

        var $searchField = that._getSearchFieldElt($contentElt);
        if (inputVal) {
            // If Dx Navigator is enabled, we need to set the default query value using a helper
            // that is React-friendly
            if (el8Globals.FEATURES.BillDxNavigator) {
                var dxNavInputElement = $searchField[0]
                that._handleSetDxNavDefaultQuery(dxNavInputElement, inputVal);
            }
            // If Dx Navigator is disabled, we can set the default query value directly using jQuery
            else {
                $searchField.val(inputVal).trigger('keyup');
            }
        }
        $searchField.focusFocus();
    };

    var _add = function (spec) {
        that.setTitle('Add Patient Problem');

        $('.term-list-section', $contentElt).hide();
        $('.term-search-section', $contentElt).show();

        if (description) {
            form.populate({'description': description});

            if (_mindreader) {
                _mindreader.setInputVal(description);
                _mindreader.requestResults(description);
            }
        }
        if (details) {form.populate({'details': details}); }

        var $searchField = that._getSearchFieldElt($contentElt);
        if (spec.defaultSearch) {
            // If Dx Navigator is enabled, we need to set the default query value using a helper
            // that is React-friendly
            if (el8Globals.FEATURES.BillDxNavigator) {
                var dxNavInputElement = $searchField[0]
                that._handleSetDxNavDefaultQuery(dxNavInputElement, spec.defaultSearch);
            }
            // If Dx Navigator is disabled, we can set the default query value directly using jQuery
            else {
                $searchField.val(spec.defaultSearch).trigger('keyup');
            }
        }
        $searchField.focusFocus();
    };

    var _bindTriggers = function () {
        $contentElt.on('click', '.add-trigger',  function(event) {
            // show and focus the MR
            $('.term-search-section', $contentElt).show();
            $('.add-trigger-section', $contentElt).hide();
            that._getSearchFieldElt($contentElt).focusFocus();
            that.adjustHeight();
        });

        $contentElt.on('click', '.term-remove-trigger',  function(event) {
            var termId = null;
            var $termItem = $(this).closest('.term-item');
            if ($termItem.length) {
                termId = $termItem.data('id');
                $termItem.remove();
                localImoCodeIds = _(localImoCodeIds).without(termId);

                if (!$('.term-item', that.getContentElt()).length) {
                    // If removed last, reset form
                    $('.term-list-section', $contentElt).hide();
                    $('.term-search-section', $contentElt).show();
                    that._getSearchFieldElt($contentElt).focusFocus();
                }
            }

            that.adjustHeight();
        });
    };

    //
    // Public
    //

    // spec can contain:
    // - problem: the current problem obj
    // - description: text
    // - details: text (from "add problem" in A or A/P section of a VN)
    // - saveCb(item): used by VNs
    var super_show = that.show;
    that.show = function(spec) {
        super_show.call(that);
        spec = spec || {};
        currProblem = spec.problem || null;
        description = spec.description || null;
        details = spec.details || null;
        saveCb = spec.saveCb || null;
        localImoCodeIds = [];

        _refresh();

        if (currProblem) {
            _insertCurrentProblem();
            if (currProblem.getImoIds().length) {
                _edit();
            } else {
                var needsCrosswalkCount = el8.ptdata.ptProblems.sorted().filter(function(p) {
                    return !p.getImoIds().length;
                }).length;

                _crosswalk(needsCrosswalkCount === 1 ? true : false); // isLast?
            }
        } else {
            _add(spec);
        }

        that.adjustHeight();
        _bindTriggers();
    };

    var super_hide = that.hide;
    that.hide = function() {
        currProblem = null;
        description = null;
        details = null;
        saveCb = null;
        localImoCodeIds = [];
        fallbackToIcd9 = false;

        // destroy tooltips
        _($contentElt.find('div.has-tippy')).each(function (elt) {
            el8.service.tooltip.destroy($(elt));
        });

        super_hide.call(that);
        _refresh();
    };

    return that;

})();
